import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://whvafphwpkastjkcjrzs.supabase.co'
const SUPABASE_KEY = 'sb_publishable_Cv54UnrSd6dQgQN7FYrPqA_fuUj77A5'

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)
